import PropTypes from 'prop-types';
import React from 'react';

const TodoIcon = ({ style, className = '' }) => {
  return (
    <svg
      style={style}
      className={`sa-icon__todo ${className}`}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>To-Do</title>
      <g clipPath="url(#clip0_3892_29219)">
        <path
          d="M4.01585 8.71946C4.3526 8.37286 4.90656 8.36494 5.25315 8.70168C5.59909 9.03849 5.60747 9.59261 5.27093 9.93898L2.59944 12.687C2.43637 12.8549 2.21273 12.9504 1.97874 12.9523C1.74452 12.954 1.51822 12.8622 1.35257 12.6966L0.253351 11.5974C-0.0883854 11.2557 -0.088328 10.7004 0.253351 10.3587C0.594985 10.0175 1.14905 10.0174 1.49065 10.3587L1.96234 10.8317L4.01585 8.71946ZM13.1268 9.82824C13.61 9.82824 14.0018 10.22 14.0018 10.7032C14.0017 11.1864 13.61 11.5782 13.1268 11.5782H7.19046C6.70736 11.5781 6.31553 11.1864 6.31546 10.7032C6.31546 10.2201 6.70732 9.82837 7.19046 9.82824H13.1268ZM4.01585 1.31203C4.35262 0.96559 4.90661 0.957558 5.25315 1.29426C5.59921 1.63102 5.60741 2.18513 5.27093 2.53156L2.59944 5.28097C2.4364 5.44865 2.21261 5.54434 1.97874 5.5462C1.74452 5.54791 1.51822 5.4548 1.35257 5.28918L0.253351 4.18995C-0.0883565 3.84831 -0.0882412 3.2944 0.253351 2.95266C0.595033 2.61092 1.14892 2.61098 1.49065 2.95266L1.96234 3.42434L4.01585 1.31203ZM13.1268 2.42082C13.61 2.42082 14.0017 2.81266 14.0018 3.29582C14.0018 3.77907 13.61 4.17082 13.1268 4.17082H7.19046C6.70732 4.17069 6.31546 3.77898 6.31546 3.29582C6.31556 2.81273 6.70739 2.42096 7.19046 2.42082H13.1268Z"
          fill="#292F34"
        />
      </g>
      <defs>
        <clipPath id="clip0_3892_29219">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TodoIcon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
};

export default TodoIcon;
